/*
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2022-12-16 15:30:56
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-09 16:17:48
 * @FilePath: /platform/src/store/menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import portal from '@/api/portal.js'

const state = {
  menus: JSON.parse(sessionStorage.getItem('currentMenus')) || [],
  companyNameHasLeft: JSON.parse(sessionStorage.getItem('companyNameHasLeft')) || false
}

const getters = {
  menus: function (state) {
    return state.menus
  }
}

const actions = {
  actionMenus({ commit, state }) {
    return new Promise((resolve, reject) => {
      // if (state.menus && state.menus.length >= 1) {
      //   resolve();
      //   return;
      // }
      portal.getMenus().then((data) => {
        const currentTenantId = sessionStorage.getItem('currentTenantId')
        data.forEach((e) => {
          if (e.alias == 'billing_center' && e.children.length && !(currentTenantId && currentTenantId != '-1')) {
            e.children = e.children.filter((v) => {
              return v.alias != 'billing_center_inner'
            })
          }
        })
        sessionStorage.setItem('currentMenus', JSON.stringify(data))
        commit('mutationMenus', data)
        resolve(data)
      })
    })
  },
  actionMenusEmpty({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('mutationMenus', [])
    })
  },
  getHasLeft({ commit, state }, data) {
    commit('GETHASLEFT', data)
  },
  removeHasLeft({ commit, state }, data) {
    commit('GETHASLEFT', data)
  },
  //附件在线预览
  onlinePreview({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      portal.onlinePreview(id, (response) => {
        resolve(response.data)
      })
    })
  },
  //附件下载
  downloadFile({ commit, state }, id) {
    portal.downloadFile(id)
  },
  //获取用户头像
  downloadImg({ commit, state }, fileId) {
    return new Promise((resolve, reject) => {
      portal.downloadImg(fileId, (response) => {
        resolve(response)
      })
    })
  },
  // 当前菜单绑定的仪表盘路径
  getCurrentDashboard({ commit }, url) {
    commit('setCurrentDashboard', url)
  }
}

const mutations = {
  mutationMenus(state, menus) {
    function modify(menus) {
      menus.map((item, index) => {
        if (item.menuType === 1) {
          menus.splice(index, 1)
        } else {
          if (item.children && item.children.length) {
            // 递归调用
            modify(item.children)
          }
        }
        return item
      })
      return menus
    }
    modify(menus)
    state.menus = menus
  },
  setCurrentDashboard(state, response) {
    state.currentDashboard = response
  },
  GETHASLEFT(state, data) {
    sessionStorage.setItem('companyNameHasLeft', JSON.stringify(data))
    state.companyNameHasLeft = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
